"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronUp = function ChevronUp(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M5.88174 12.8684C5.9301 12.9167 5.98752 12.9551 6.05071 12.9813C6.1139 13.0075 6.18163 13.0209 6.25002 13.0209C6.31842 13.0209 6.38615 13.0075 6.44934 12.9813C6.51253 12.9551 6.56995 12.9167 6.61831 12.8684L12.5 6.98663L18.3817 12.8684C18.4794 12.966 18.6119 13.0209 18.75 13.0209C18.8881 13.0209 19.0206 12.966 19.1183 12.8684C19.216 12.7707 19.2708 12.6382 19.2708 12.5001C19.2708 12.362 19.216 12.2295 19.1183 12.1318L12.8683 5.8818C12.8199 5.83343 12.7625 5.79507 12.6993 5.76889C12.6361 5.74272 12.5684 5.72925 12.5 5.72925C12.4316 5.72925 12.3639 5.74272 12.3007 5.76889C12.2375 5.79507 12.1801 5.83343 12.1317 5.8818L5.88171 12.1318C5.83335 12.1802 5.79498 12.2376 5.76881 12.3008C5.74264 12.364 5.72917 12.4317 5.72917 12.5001C5.72917 12.5685 5.74265 12.6362 5.76883 12.6994C5.795 12.7626 5.83337 12.82 5.88174 12.8684Z",
    fill: props.foregroundColor
  }));
};

ChevronUp.defaultProps = {
  altText: "Chevron Up",
  foregroundColor: "#2D5AB4"
};
ChevronUp.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ChevronUp;
exports.default = _default;